import { useEffect, useRef, useState } from "react";
import { adaptFile, postBlankFile } from "../../api/GPT";
import FileUploaderNBK from "../shared/components/FileUploader";

import { v4 as uuidv4 } from "uuid";

import "../../App.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Takoyaki from "../shared/components/TakoyakiIcon";
import { Button, Row, Steps } from "antd";
import { BASE_URL } from "../../api/Constants";
import TextArea from "antd/es/input/TextArea";

const AskGPT = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { idEpisode } = useParams();
  const { episode, serie } = state;

  console.log("state", state);

  const [codeSerie, setCodeSerie] = useState(serie.uid.replaceAll("_", " "));
  const [txtToAdapt, setTxtToAdapt] = useState("");
  const [modelType, setModelType] = useState("gpt-3.5-turbo-0613");
  const [file, setFile] = useState(null);

  const uidClient = useRef(uuidv4());
  const sse = useRef();
  const [isListening, setIsListening] = useState(false);
  const [dataLoader, setDataLoader] = useState({
    percent: 0,
    step: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isListening) {
      console.log("Load sse", uidClient.current);
      sse.current = new EventSource(`${BASE_URL}/events/${uidClient.current}`, {
        withCredentials: true,
      });

      sse.current.onopen = (e) => {
        console.log("On OPEN", e, uidClient.current);
        setIsListening(true);
      };

      sse.current.onerror = (e) => {
        console.log("Error SSE : ", e);
        sse.current.close();
      };

      sse.current.onmessage = (msg) => {
        console.log("ON Message :", msg.data);
        const tmpData = JSON.parse(msg.data);
        setDataLoader(tmpData);
      };
    }
  }, [isListening]);

  const onFileDrop = (file) => {
    console.log(file);
    setFile(file);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const hasFile = file !== null && file.length > 0;
    try {
      if (!hasFile && txtToAdapt.length <= 0) return;

      setIsLoading(true);

      const formData = new FormData();

      if (hasFile) {
        const f = file[0];
        formData.append("txtFile", f);
      } else {
        formData.append(
          "txtFile",
          new File([txtToAdapt], "txtFile.txt", {
            type: "text/plain",
          })
        );
      }

      formData.append("storeType", "nbk-doc");
      formData.append("codeSerie", codeSerie);
      formData.append("modelType", modelType);
      formData.append("epNumber", episode.number);
      formData.append("idEp", idEpisode);
      formData.append("idClient", uidClient.current);

      const res = await adaptFile(formData);
      // console.log("ADAPT FILE :", res);
      if (res && res.uid) navigate(`/doc/${res.uid}`);

      setIsLoading(false);
    } catch (error) {
      // Consider implementing your own error handling logic here
      console.error(error);
      alert(error.message);
    }
  };

  const createBlankFile = async () => {
    try {
      setIsLoading(true);

      const res = await postBlankFile({
        codeSerie,
        epNumber: episode.number,
        idEp: idEpisode,
        idSeason: episode.SeasonId,
      });

      if (res && res.uid) navigate(`/doc/${res.uid}`);

      setIsLoading(false);
    } catch (error) {
      // Consider implementing your own error handling logic here
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <div>
      <main className="main">
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Takoyaki style={{ marginRight: 10 }} />
          <h1>TakoIAki</h1>
        </div>
        <h5>{`EP${episode.number} - ${episode.name}`}</h5>
        {isLoading ? (
          <Row>
            <Steps
              direction="vertical"
              current={Number(dataLoader.step)}
              percent={Number(dataLoader.percent)}
              items={[
                {
                  title: "Envoi du fichier",
                  description: "",
                },
                {
                  title: "Adaptation",
                  subTitle: `${dataLoader.percent}%`,
                  description: "",
                },
                {
                  title: "Enregistrement",
                  description: "",
                },
              ]}
            />
          </Row>
        ) : (
          <>
            <form onSubmit={onSubmit}>
              <FileUploaderNBK onFileDrop={onFileDrop} file={file} />
              <label>OU Transférer du texte (car. {txtToAdapt.length})</label>
              <TextArea
                name="txtToAdapt"
                placeholder="Il était une fois Lulu à Brest qui allait à la plage faire du surf..."
                autoSize={{ minRows: 3, maxRows: 5 }}
                maxLength={9000}
                onChange={(v) => setTxtToAdapt(v.target.value)}
                value={txtToAdapt}
              />
              <br />
              <label>Code Série</label>
              <input
                type="text"
                name="serieCode"
                value={codeSerie}
                onChange={(e) => setCodeSerie(e.target.value)}
                contentEditable={!isLoading}
              />
              <label>Modèle</label>
              <select
                name="modelType"
                value={modelType}
                onChange={(e) => setModelType(e.target.value)}
              >
                <option value="gpt-3.5-turbo-0613">GPT-3.5</option>
                <option value="gpt-4">GPT-4</option>
              </select>
              <input
                disabled={isLoading}
                type="submit"
                value={isLoading ? "Chargement..." : "Adapter le texte"}
              />
            </form>
            <Button style={{ marginBottom: 24 }} onClick={createBlankFile}>
              Créer un épisode vierge
            </Button>
            <Button
              style={{ marginBottom: 24 }}
              onClick={() =>
                navigate(`/serie/${serie.id}/details`, {
                  replace: true,
                  state: {
                    serie,
                  },
                })
              }
            >
              Revenir en arrière
            </Button>
          </>
        )}
      </main>
    </div>
  );
};

export default AskGPT;
